// extracted by mini-css-extract-plugin
export default {"addCard":"MainCardAdd_addCard__TedoP","star":"MainCardAdd_star__6n4bD","button":"MainCardAdd_button__ta2JG"};